import React from 'react';
import { useTheme } from '../context/ThemeContext';
import AnimatedBackground from './AnimatedBackground'; // Component nền hạt

// Component đơn giản cho nền gradient
const GradientBackground = () => <div className="gradient-background"></div>;

const DynamicBackground: React.FC = () => {
  const { theme } = useTheme();

  return (
    <div className="app-background-container">
      {/* Nếu là theme tối thì hiện hạt, ngược lại hiện gradient */}
      {theme === 'dark' ? <AnimatedBackground /> : <><GradientBackground /> <AnimatedBackground /></>}
    </div>
  );
};

export default DynamicBackground;